import axios from 'axios'
import {NOTIFICATION_DANGER} from "../../constants/common";
import _ from 'lodash'

// initial state
const state = {
    currentEmployee: {},
    fullScreen: false,
    people: [],
    groups: [],
    //-----------
    lists: [],
    test:[
        { title: null }
    ],
    answers: [],
    testAnswers: [],
    testResults: [],
};

// getters
const getters = {
    getGroup: state => index => {
        return state.groups[index]
    }
};

// actions
const actions = {
    getPeople({commit}) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                axios.get('/api/people.json')
                    .then((response) => {
                        commit('setPeople', response.data.people);
                        commit('setGroups', response.data.groups);
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000});
                        reject()
                    });
                resolve()
            },1000);
        });
    },
    setEmployee({commit}, employee){
        commit('setEmployee', employee);
        _.isEmpty(employee) ? this.commit('setNavVisible', true) : this.commit('setNavVisible', false);
    },
    saveEmployeeStatus({dispatch}, status) {
        return new Promise((resolve) => {
            setTimeout(() => {
                axios.get('/api/employee.json')
                    .then((response) => {
                        let employee = response.data.employee;
                        employee.status = status;
                        dispatch('setEmployee', employee);
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                    });
                resolve()
            },10);
        });
    },
    getEmployee({dispatch}, id) {
        return new Promise((resolve) => {
            setTimeout(() => {
                axios.get('/api/employee.json', { params: { id: id }})
                    .then((response) => {
                        dispatch('setEmployee', response.data.employee);
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {
                            type: NOTIFICATION_DANGER,
                            text: "Server error",
                            time: 10000
                        })
                    });
                resolve()
            }, 100);
        });
    },
    updateNote({commit}, {id, note}) {
        return new Promise((resolve) => {
            setTimeout(() => {
                axios.get('/api/employee.json')
                    .then(() => {
                        let today = new Date();
                        let date = today.getDate() + '.'+(today.getMonth()+1)+'.'+ today.getFullYear();
                        commit('updateNote', {id: id, note: note, date: date});
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                    });
                resolve()
            },300);
        });
    },
    addNote({commit}, note) {
        return new Promise((resolve) => {
            setTimeout(() => {
                axios.get('/api/employee.json')
                    .then(() => {
                        let today = new Date();
                        let date = today.getDate() + '.'+(today.getMonth()+1)+'.'+ today.getFullYear();
                        commit('addNote', {id: 453545, text: note, date: date});
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                    });
                resolve()
            },300);
        });
    },

    //------------------------------
    getQuestions({commit}) {
        //todo: для симуляции загрузки, потом удалить
        return new Promise((resolve) => {
            setTimeout(() => {
                axios.get('/api/people-questionnaire.json')
                    .then((response) => {
                        commit('setLists', response.data.lists);
                        commit('setAnswers', response.data.answers);
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                    });
                resolve()
            },1000);
        });

    },
    getTestQuestions({commit}) {
        return new Promise((resolve) => {
            setTimeout(() => {
                axios.get('/api/people-test.json')
                    .then((response) => {
                        commit('setTestLists', response.data.lists);
                        commit('setTestAnswers', response.data.answers);
                        commit('setTestResults', response.data.results);
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                    });
                resolve()
            },1000);
        });
    },
    saveProfile({dispatch}, employee) {
        return new Promise((resolve) => {
            setTimeout(() => {
                axios.get('/api/people-test.json')
                    .then(() => {
                       dispatch('setEmployee', employee);
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                    });
                resolve()
            },1000);
        });
        //todo: для симуляции загрузки, потом удалить
    },
};

// mutations
const mutations = {
    //----------------------------
    setLists (state, array) {
        state.lists = array
    },
    setTestLists (state, array) {
        state.test = array
    },
    setAnswers (state, array) {
        state.answers = array
    },
    setTestAnswers (state, array) {
        state.testAnswers = array
    },
    setTestResults (state, array) {
        state.testResults = array
    },
    //-----------------------------

    setFullScreen (state, value) {
        state.fullScreen = value;
    },
    setPeople (state, people) {
        state.people = people
    },
    setGroups (state, groups) {
        state.groups = groups
    },
    setEmployee (state, employee) {
        state.currentEmployee = employee
    },
    updateNote(state, note) {
        let index = state.currentEmployee.notes.findIndex(x => x.id === note.id);
        if (index !== -1) {
            state.currentEmployee.notes.splice(index, 1, note );
        }
    },
    addNote(state, note) {
        state.currentEmployee.notes.unshift(note)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}